import { useEffect, useState } from 'react';
import { useAdminApi } from './use-admin';

// Session cache so we fetch the current admin's permissions only once.
let cache = null;
export const clearAdminPermsCache = () => { cache = null; };

/**
 * Returns the signed-in admin's effective permissions.
 * { loading, isSuper, permissions, name, roleLabel, has(perm) }
 * An admin with no role (or a super role) is super → has() always true.
 */
export const useAdminPerms = () => {
  const api = useAdminApi();
  const [state, setState] = useState(cache || { loading: true, isSuper: false, permissions: [] });

  useEffect(() => {
    if (cache) { setState(cache); return; }
    let active = true;
    api.get('/me')
      .then((d) => {
        const s = { loading: false, isSuper: !!d.super, permissions: d.permissions || [], name: d.name, roleLabel: d.role_label, role: d.role };
        cache = s;
        if (active) setState(s);
      })
      .catch(() => {
        const s = { loading: false, isSuper: true, permissions: [] };
        if (active) setState(s);
      });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const has = (perm) => state.isSuper || (state.permissions || []).includes(perm);
  return { ...state, has };
};

export default useAdminPerms;
